// @ts-nocheck
import Fuse from "fuse.js"

export default class SearchProviders {
	constructor({ providers } = {}) {
		this.providers = Array.isArray(providers) ? providers : []
		this.fuse =
			this.providers.length > 0
				? new Fuse(this.providers, { keys: ["name"] })
				: null
	}

	search({ provider }) {
		if (!this.providers.length || !this.fuse) {
			return []
		}

		if (provider === "") return this.providers
		else if (typeof provider === "string") {
			return this.fuse.search(provider).map((provider) => provider.item)
		}
	}
}
